export default "__VITE_ASSET__aSkBA5HO__"